<ng-container  *transloco="let t; scope: 'task-template/' + translationResourcePath">
    <div *ngIf="formData && formSchema && !loadingFormControls" id="task-content">
        <div class="body-wrapper scrollbar">
            <div class="form-wrapper">
                <div class="details">
                    <form [formGroup]="dynamicFormGroup">
                        <div id="pdf-content" class="input-form">
                            <ng-container *transloco="let t; scope: 'task-template/' + translationResourcePath">
                                <div formArrayName="dynamicFormArray"
                                    *ngFor="let section of formSchema?.formBody; let index = index" class="p-relative">
                                    <div *ngIf="section?.isDisplayedOnUI && !sectionHidden(section, index)"
                                        [ngClass]="{ section: section.isDisplayedOnUI && !onDialogWindow }">
                                        <div class="section-label">
                                            <ng-container [ngTemplateOutlet]="translatedText" [ngTemplateOutletContext]="{
                                                    field: section?.sectionHeader,
                                                    t: t
                                                }"></ng-container>
                                        </div>
                                        <p class="section-text" *ngIf="section.sectionDescription">
                                            <ng-container [ngTemplateOutlet]="translatedText" [ngTemplateOutletContext]="{
                                                    field: section?.sectionDescription,
                                                    t: t
                                                }"></ng-container>
                                        </p>
                                        <div *ngIf="!onDialogWindow && section?.editableGridProps?.actions"
                                            class="section-actions">
                                            <ng-container *ngFor="let action of section?.editableGridProps?.actions">
                                                <ng-container>
                                                    <div class="new-item-grid">
                                                        <div class="add-new-button-container"
                                                            (click)="sectionActionClick(section, index)" fxLayout="row"
                                                            fxLayoutGap="10px" fxLayoutAlign="auto center">
                                                            <tsl-icon tslSuffix size="small" class="add-icon">
                                                                add_circle_outline</tsl-icon>
                                                            <div class="button-label">{{ action }}</div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                            <table class="table" *ngIf="getSectionTableData(index)?.length > 0">
                                                <tr>
                                                    <th *ngFor="
                                                            let item of section.editableGridProps.tableColumns;
                                                            let dataIndex = index
                                                        " class="table-header">
                                                        <tsl-label i18n class="task-info-label">
                                                            {{ item.displayName }}</tsl-label>
                                                    </th>
                                                    <th>
                                                        <tsl-label i18n="@@030b4423b92167200e39519599f9b863b4f7c62c" t="030b4423b92167200e39519599f9b863b4f7c62c" class="task-info-label">Actions</tsl-label>
                                                    </th>
                                                </tr>
                                                <tr *ngFor="
                                                        let data of getSectionTableData(index);
                                                        let dataIndex = index
                                                    ">
                                                    <td class="table-data"
                                                        *ngFor="let item of section.editableGridProps.tableColumns">
                                                        {{ data[item?.key] }}
                                                    </td>
                                                    <td>
                                                        <tsl-icon (click)="onEditObject(index, dataIndex, section)"
                                                            tslSuffix size="small" class="icon">edit</tsl-icon>
                                                        <tsl-icon tslSuffix size="small"
                                                            (click)="onRemoveObject(index, dataIndex)" class="icon">
                                                            delete</tsl-icon>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <ng-container *ngIf="section?.fields?.length" [formGroupName]="index">
                                            <table *ngIf="section?.isTableView" tsl-table
                                                [dataSource]="dynamicFormArray?.controls[index]?.controls"
                                                class="section-table">
                                                <ng-container *ngFor="let field of section.fields"
                                                    [tslColumnDef]="field.key">
                                                    <th tsl-header-cell *tslHeaderCellDef
                                                        fxFlex="{{ calculateFormat(field) }}">
                                                        <tsl-label i18n class="task-info-label">
                                                            <ng-container [ngTemplateOutlet]="translatedText"
                                                                [ngTemplateOutletContext]="{
                                                                    field: field?.displayName,
                                                                    t: t
                                                                }"></ng-container>
                                                        </tsl-label>
                                                    </th>
                                                    <td tsl-cell *tslCellDef="let formGroup; let rowIndex = index"
                                                        [formGroupName]="rowIndex" fxFlex="{{ calculateFormat(field) }}"
                                                        fxLayoutAlign="center center">
                                                        <ng-container [ngTemplateOutlet]="formField"
                                                            [ngTemplateOutletContext]="{
                                                                field: field,
                                                                section: section,
                                                                formGroup: dynamicFormArray.at(index).at(rowIndex)
                                                            }">
                                                        </ng-container>
                                                    </td>
                                                </ng-container>
                                                <tr tsl-header-row
                                                    *tslHeaderRowDef="getSectionTableDisplayedCols(section)"></tr>
                                                <tr tsl-row *tslRowDef="
                                                        let row;
                                                        columns: getSectionTableDisplayedCols(section);
                                                        let rowIndex = index
                                                    "></tr>
                                            </table>
                                            <div *ngIf="!section.isTableView" class="row col-md-12">
                                                <ng-container *ngFor="let field of section?.fields">
                                                    <div *ngIf="field.isDisplayed && !fieldHidden(field, dynamicFormArray?.at(index))" [ngClass]="
                                                            field.colSize ? 'col-md-' + field.colSize : 'col-md-6'
                                                        ">
                                                        <task-attachments *ngIf="field.type == 'attachments'"
                                                            [taskId]="this.formData.id" [filesKey]="field.key"
                                                            [files]="getAttachments(field)"
                                                            [isDocumentLocalStorage]="isDocumentLocalStorage"
                                                            [toGetFileFromUrl]="toGetFileFromUrl(field)">
                                                        </task-attachments>
                                                        <ng-container [ngTemplateOutlet]="formField"
                                                            [ngTemplateOutletContext]="{
                                                                field: field,
                                                                section: section,
                                                                formGroup: dynamicFormArray?.at(index)
                                                            }">
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                        <ng-template #formField let-field="field" let-section="section"
                                            let-formGroup="formGroup">
                                            <div class="w-100 p0" [ngSwitch]="field.type" [formGroup]="formGroup"
                                                [ngClass]="{ 'table-field': section?.isTableView }"
                                                *ngIf="field.type != 'attachments'">
                                                <div *ngIf="!section.isTableView" class="field-label-container">
                                                    <tsl-label i18n class="task-info-label">
                                                        <ng-container [ngTemplateOutlet]="translatedText"
                                                            [ngTemplateOutletContext]="{
                                                                field: field?.displayName,
                                                                t: t
                                                            }">
                                                        </ng-container>
                                                        <span *ngIf="field?.props?.isRequired" class="required">*</span>
                                                    </tsl-label>
                                                </div>
                                                <div *ngSwitchCase="'label'" class="field-label-value" name="txtName">
                                                    {{ formGroup.get(field.key)?.value }}
                                                </div>

                                                <tsl-form-field *ngSwitchCase="'textarea'">
                                                <textarea class="read-only-label-value"
                                                    tslInput shape="round" [formControlName]="field.key" name="txtName"
                                                    [readonly]="field.isReadonly"
                                                    [required]="field.props?.isRequired"></textarea>
                                                <tsl-hint align="end">{{formGroup.get(field.key)?.value?.length ||0}}/500</tsl-hint>
                                                </tsl-form-field>
                                                <ng-container *ngSwitchCase="'date'">
                                                    <form-date-picker
                                                        class="w-100"
                                                        [dateFormControl]="formGroup.get(field.key)"
                                                        [field]="field"
                                                        [formData]="formData"
                                                    ></form-date-picker>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'dropdown'">
                                                    <div *ngIf="field.isReadonly; else dropdown">
                                                        <div class="field-label-value">
                                                            {{ formData[field.key] }}
                                                        </div>
                                                    </div>
                                                    <ng-template #dropdown>
                                                        <tsl-form-field class="w-100 p0">
                                                            <tsl-select
                                                                [formControlName]="field.key"
                                                                class="max-w"
                                                                (selectionChange)="
                                                                    emitChange(
                                                                        field,
                                                                        formGroup.get(field.key)
                                                                    )
                                                                "
                                                            >
                                                                <tsl-option
                                                                    *ngFor="
                                                                        let option of field?.props?.options ||
                                                                        initialContactsOnLoad[field.key]
                                                                    "
                                                                    [value]="option.value"
                                                                >
                                                                    {{ translate.get(option.displayName) }}
                                                                </tsl-option>
                                                                <tsl-option
                                                                    *ngIf="
                                                                        field?.props?.options?.length === 0
                                                                    "
                                                                >
                                                                    'No results found'
                                                                </tsl-option>
                                                            </tsl-select>
                                                        </tsl-form-field>
                                                    </ng-template>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'multiAutocomplete'">
                                                    <app-multiselect-autocomplete class="w-100 table-field"
                                                        [formData]="formData"
                                                        [multiselectFormControl]="formGroup.get(field.key)"
                                                        [field]="field" [initialContactsOnLoad]="initialContactsOnLoad">
                                                    </app-multiselect-autocomplete>
                                                </ng-container>

                                                <ng-container *ngSwitchCase="'checkbox'">
                                                    <tsl-checkbox
                                                    [disabled]="field?.isDisabled || field.isReadonly"
                                                    [formControlName]="field.key"
                                                    (change)="onCheckBoxSelection(field, formGroup.get([field.key]))"
                                                >
                                                {{ translate.get(field.props.options[0].displayName.displayText) }}
                                                </tsl-checkbox>
                                                </ng-container>

                                                <tsl-form-field *ngSwitchCase="'autocomplete'">
                                                    <input tslInput autocomplete="off" placeholder="Search"
                                                        class="read-only-label-value" tPlaceholder="7e892ba15f2c6c17e83510e273b3e10fc32ea016" i18n-placeholder="@@7e892ba15f2c6c17e83510e273b3e10fc32ea016" minlength="3"
                                                        [formControlName]="field.key" [tslAutocomplete]="auto"
                                                        name="txtName" fullWidth (keyup)="
                                                            onAutocompleteKeyUp($event, formGroup.get(field.key), field)
                                                        " [readonly]="field.isReadonly" />
                                                    <tsl-icon tslSuffix [readonly]="field.isReadonly"
                                                        class="searchIcon">search</tsl-icon>
                                                    <tsl-autocomplete #auto="tslAutocomplete" (optionSelected)="
                                                            onSelection($event, field.key, formGroup.get(field.key))
                                                        " [contentWidth]="'content'">
                                                        <ng-container *ngIf="showSpinner">
                                                            <tsl-option [tslSpinner]="true" tslSpinnerSize="small">
                                                            </tsl-option>
                                                        </ng-container>
                                                        <tsl-option
                                                            *ngFor="let option of suggestionDictionary[field.key]"
                                                            [value]="option.value">
                                                            {{ option.displayName }}
                                                        </tsl-option>
                                                        <tsl-option *ngIf="suggestionDictionary?.length === 0">
                                                            {{ 'No results found' }}
                                                        </tsl-option>
                                                    </tsl-autocomplete>
                                                </tsl-form-field>
                                                <!-- <tsl-form-field *ngSwitchCase="'autocomplete'">
                                                    <input
                                                        tslInput
                                                        autocomplete="off"
                                                        placeholder="Search"
                                                        class="read-only-label-value min-w"
                                                        i18n-placeholder
                                                        minlength="3"
                                                        [formControlName]="field.key"
                                                        [tslAutocomplete]="auto"
                                                        name="txtName"
                                                        (change)="emitChange(field)"
                                                        (keyup)="
                                                            onAutocompleteKeyUp(
                                                                $event,
                                                                formGroup.get(field.key),
                                                                field
                                                            )
                                                        "
                                                        [readonly]="field.isReadonly"
                                                    />
                                                    <tsl-icon
                                                        tslSuffix
                                                        disabled="field.isReadonly"
                                                        class="searchIcon"
                                                        >search</tsl-icon
                                                    >
                                                    <tsl-autocomplete
                                                        #auto="tslAutocomplete"
                                                        (optionSelected)="
                                                            onSelection(
                                                                $event,
                                                                field,
                                                                formGroup.get(field.key)
                                                            )
                                                        "
                                                        [contentWidth]="'content'"
                                                    >
                                                        <ng-container *ngIf="showSpinner">
                                                            <tsl-option
                                                                [tslSpinner]="true"
                                                                tslSpinnerSize="small"
                                                            >
                                                            </tsl-option>
                                                        </ng-container>
                                                        <tsl-option
                                                            *ngFor="
                                                                let option of suggestionDictionary[
                                                                    field.key
                                                                ]
                                                            "
                                                            [value]="option.value"
                                                        >
                                                            {{ option.displayName }}
                                                        </tsl-option>
                                                        <tsl-option
                                                            *ngIf="suggestionDictionary?.length === 0"
                                                        >
                                                            {{ 'No results found' }}
                                                        </tsl-option>
                                                    </tsl-autocomplete>
                                                </tsl-form-field> -->
                                                <tsl-radio-group *ngSwitchCase="'radio-button'" name="txtName"
                                                    [formControlName]="field.key" [disabled]="field.isReadonly"
                                                    [required]="field.props?.isRequired">
                                                    <tsl-radio-button *ngFor="let option of field.props?.options"
                                                        [value]="option.value">
                                                        {{ translate.get(option.displayName) }}
                                                    </tsl-radio-button>
                                                </tsl-radio-group>
                                                <app-phone-field *ngSwitchCase="'phone'"
                                                    [formField]="formGroup.get(field.key)"></app-phone-field>

                                                <app-address *ngSwitchCase="'address'" [field]="field"
                                                    [address]="formData[field.key]"
                                                    [formField]="formGroup.get(field.key)"></app-address>

                                                <ng-container *ngSwitchCase="'richTextEditor'">
                                                    <quill-editor *ngIf="!field.isReadonly" [modules]="rteModules"
                                                        [readonly]="field.isReadonly"
                                                        [required]="field.props?.isRequired"
                                                        [formControlName]="field.key" [placeholder]="'Description'"
                                                        (onEditorCreated)="
                                                            onEditorCreated(
                                                                $event,
                                                                dynamicFormArray?.controls[index]?.controls[field.key]
                                                            )
                                                        "></quill-editor>
                                                    <quill-view *ngIf="field.isReadonly" [content]="
                                                            _htmlDecode(
                                                                dynamicFormArray?.controls[index]?.controls[field.key]
                                                                    ?.value
                                                            )
                                                        " theme="snow"></quill-view>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'file-upload'">
                                                <dynamic-form-file-upload
                                                        (fileChange)="
                                                            onFileFormControlChange(
                                                                $event,
                                                                dynamicFormArray?.controls[index]?.controls[field.key]
                                                            )
                                                        "
                                                        (fileActionChange)="fieldFileAction($event)"
                                                        [uploadedFiles]="getFieldAttachments(field)"
                                                        [field] = "field"
                                                        [accept]="field?.props?.accept"
                                                        [multiple]="field?.props?.multiple"
                                                        [disableAction]="field?.isReadonly"
                                                    ></dynamic-form-file-upload>
                                                </ng-container>
                                                <input *ngSwitchDefault class="read-only-label-value" tslInput
                                                    shape="round" [formControlName]="field.key" name="txtName"
                                                    [readonly]="field.isReadonly" />
                                                <tsl-error class="error-message" *ngIf="
                                                        (dynamicFormArray?.controls[index]?.controls[field.key]
                                                            ?.touched &&
                                                            dynamicFormArray?.controls[index]?.controls[field.key]
                                                                ?.invalid) ||
                                                        formDataValidation?.errors[field.key] != null
                                                    ">
                                                    <ng-container *ngIf="formDataValidation?.errors[field.key]">
                                                        {{
                                                            t(
                                                                getTemplateTranslationScope(
                                                                    translationResourcePath,
                                                                    formDataValidation.errors[field.key]
                                                                )
                                                            ) || formDataValidation.errors[field.key]
                                                        }}
                                                    </ng-container>

                                                    <ng-container *ngIf="
                                                            dynamicFormArray?.controls[index]?.controls[field.key]
                                                                .errors.required
                                                        ">
                                                        {{
                                                            t(
                                                                getTemplateTranslationScope(
                                                                    translationResourcePath,
                                                                    field.displayName.displayText + ' is required.'
                                                                )
                                                            ) || field.displayName.displayText + ' is required.'
                                                        }}
                                                    </ng-container>
                                                    <ng-container *ngIf="
                                                            dynamicFormArray?.controls[index]?.controls[field.key]
                                                                .errors.pattern
                                                        ">
                                                        {{
                                                            t(
                                                                getTemplateTranslationScope(
                                                                    translationResourcePath,
                                                                    field.displayName.displayText + ' is not valid.'
                                                                )
                                                            ) || field.displayName.displayText + ' is not valid.'
                                                        }}
                                                    </ng-container>
                                                    <ng-container *ngIf="
                                                            dynamicFormArray?.controls[index]?.controls[field.key]
                                                                .errors.error
                                                        ">
                                                        {{
                                                            t(
                                                                getTemplateTranslationScope(
                                                                    translationResourcePath,
                                                                    dynamicFormArray?.controls[index]?.controls[field.key].errors.error
                                                                )
                                                            ) || dynamicFormArray?.controls[index]?.controls[field.key].errors.error
                                                        }}
                                                    </ng-container>
                                                </tsl-error>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="secondary-action-section"
                                    *ngFor="let secondaryAction of getSecondaryActions()">
                                    <div class="secondary-action-label">
                                        <ng-container [ngTemplateOutlet]="translatedText" [ngTemplateOutletContext]="{
                                                field: secondaryAction?.sectionDescription,
                                                t: t
                                            }">
                                        </ng-container>
                                    </div>
                                    <ng-container [ngSwitch]="secondaryAction.type">
                                        <ng-container *ngSwitchCase="'button'">
                                            <button tsl-button (click)="onAction(secondaryAction)"
                                                [disabled]="dynamicFormGroup.invalid">
                                                <ng-container [ngTemplateOutlet]="translatedText"
                                                    [ngTemplateOutletContext]="{
                                                        field: secondaryAction?.actionDisplayName,
                                                        t: t
                                                    }">
                                                </ng-container>
                                            </button>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'file-upload'">
                                            <dynamic-form-file-upload
                                                (fileChange)="onFileChange($event, secondaryAction)"
                                                [accept]="secondaryAction?.props?.accept"
                                                [multiple]="secondaryAction?.props?.multiple">
                                            </dynamic-form-file-upload>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'link'">
                                            <a *ngIf="secondaryAction?.props?.valueApi; else staticLink"
                                                class="action-link" (click)="onLinkClick(secondaryAction)"
                                                target="_blank">
                                                <ng-container [ngTemplateOutlet]="translatedText"
                                                    [ngTemplateOutletContext]="{
                                                        field: secondaryAction?.actionDisplayName,
                                                        t: t
                                                    }"></ng-container>
                                            </a>
                                            <ng-template #staticLink>
                                                <a *ngIf="formData?.taskTemplate?.isEsign" class="action-link"
                                                    [href]="formData?.taskRequestJson?.eSignUrl" target="_blank">
                                                    <ng-container [ngTemplateOutlet]="translatedText"
                                                        [ngTemplateOutletContext]="{
                                                            field: secondaryAction?.actionDisplayName,
                                                            t: t
                                                        }"></ng-container>
                                                </a>
                                                <a *ngIf="!formData?.taskTemplate?.isEsign" class="action-link"
                                                    [href]="formData?.taskRequestJson?.attachment" target="_blank">
                                                    <ng-container [ngTemplateOutlet]="translatedText"
                                                        [ngTemplateOutletContext]="{
                                                            field: secondaryAction?.actionDisplayName,
                                                            t: t
                                                        }"></ng-container>
                                                </a>
                                            </ng-template>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="action-container" *ngIf="getPrimaryActions()?.length > 0">
            <ng-container *transloco="let t; scope: 'task-template/' + translationResourcePath">
                <ng-container *ngFor="let action of getPrimaryActions()">
                    <ng-container *ngIf="action.type === 'checkbox'">
                        <div>
                            <tsl-checkbox [disabled]="actionDisabled(action)" [(ngModel)]="action.value"
                                (click)="onAction(action)">
                                <ng-container [ngTemplateOutlet]="translatedText" [ngTemplateOutletContext]="{
                                        field: action?.actionDisplayName,
                                        t: t
                                    }"></ng-container>
                            </tsl-checkbox>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="action.type === 'submit'">
                        <button [disabled]="actionDisabled(action) || disableSubmit() || completeTaskBusy"
                            [tslSpinner]="completeTaskBusy" [tslSpinnerSize]="'small'" type="button" tsl-button
                            color="blue" (click)="onAction(action)">
                            <ng-container [ngTemplateOutlet]="translatedText" [ngTemplateOutletContext]="{
                                    field: action?.actionDisplayName,
                                    t: t
                                }"></ng-container>
                        </button>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <ng-template #translatedText let-field="field" let-t="t">
        {{ t(getTemplateTranslationScope(translationResourcePath, field?.i18nKey)) || field?.displayText }}
    </ng-template>
    <div *ngIf="loadingFormControls" [tslSpinner]="true" style="height: calc(100vh - 140px)"></div>
</ng-container>
